// Mock data for Goo More International website

export const heroSlides = [
  {
    id: 1,
    image: "/images/products/10.png",
    title: 'Goo More',
    subtitle: 'Daha iyi bir sen için ilk adımı at!'
  },
  {
    id: 2,
    image: "/images/products/11.png",
    title: 'Yenilikçi Çözümler',
    subtitle: 'Gelişmiş Teknoloji ile Özel Ürünler'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1920&h=800&fit=crop',
    title: '15 Milyon+ Kullanıcı',
    subtitle: 'Milyonlarca İnsanın Tercihi'
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&h=800&fit=crop',
    title: '%98 Müşteri Memnuniyeti',
    subtitle: 'Kalite ve Güven ile Hizmetinizdeyiz'
  },

];

export const categories = [
  {
    id: 1,
    name: 'Goo More Transdermal Ürünler',
    image: "/images/products/1.png",
    description: 'Goo More\'ın transdermal ürünleri ile tanışın, hayat kalitenizi artırın.',
    products: [
      {
        id: 'trans-1',
        price: 2300,
        name: 'PAINLESS NIGHT GLU',
        image: "/images/products/Painless.jpg",
        description: 'Enerjini topla, kaliteli yaşa!'
      },
      {
        id: 'trans-2',
        price: 1300,
        name: 'B12 PLUS',
        image: "/images/products/b12plus.jpg",
        description: 'Vitaminlerle güçlen!'
      },
      {
        id: 'trans-3',
        price: 1400,
        name: 'DEKAMIN',
        image: "/images/products/dekamin.jpg",
        description: 'Kendini iyi hisset!'
      },
      {
        id: 'trans-4',
        price: 1600,
        name: 'OMEVIA',
        image: "/images/products/omevia.jpg",
        description: 'Kendine iyi bak!'
      },
   
{
        id: 'trans-5',
        price: 1600,
        name: 'FLEX GOO',
        image: "/images/products/flexgoo.png",
        description: 'Hareket Özgürlüğü!'
      },
   

      {
        id: 'trans-7',
        price: 2100,
        name: 'NIGHT LADIES',
        image: "/images/products/night-ladies.jpg",
        description: 'Patch formatında doğal afrodizyak!'
      },
      {
        id: 'trans-8',
        price: 2100,
        name: 'NIGHT GENTLEMEN',
        image: "/images/products/night-gentlemen.jpg",
        description: 'Patch formatında doğal afrodizyak!'
      },
      {
        id: 'trans-9',
        price: 2100,
        name: 'COLLAGEN PATCH',
        image: "/images/products/collagen.jpg",
        description: 'Yaşlanma etkilerini geciktirin!'
      }
    ]
  },
  {
    id: 2,
    name: 'Kişisel Bakım ve Hijyen',
    image: "/images/products/2.png",
    description: 'Goo More ürünleri ile doğal güzelliğinizi keşfedin, kendinize iyi bakın!',
    products: [
   
      {
        id: 'beauty-2',
        price: 2100,
        name: 'ANTI-AGING MASK 4\'lü',
        image: "/images/products/urun-10.jpg",
        description: 'Yaşlanma etkilerini geciktirin!'
      },
      {
        id: 'beauty-3',
        price: 2100,
        name: 'SUN SCREEN',
        image: "/images/products/sunscreen.png",
        description: 'Cildine ışıltı ve koruma kat!'
      },
      {
        id: 'beauty-4',
        price: 1400,
        name: 'SHAMPOO',
        image: "/images/products/shampoo.png",
        description: 'Göz alıcı saçlar için!'
      },
      {
        id: 'beauty-5',
        price: 1400,
        name: 'HAIR REPAIR MASK',
        image: "/images/products/mask.png",
        description: 'Işıl ışıl ve ipeksi saçlar!'
      },
      {
        id: 'beauty-6',
        price: 1600,
        name: 'BODY WASH',
        image: "/images/products/bodywash.png",
        description: 'Yumuşak dokunuş, ferah bir his!'
          }
  ]
},
  {
    id: 3,
    price: 1600,
    name: 'Omicoff Kahve Serisi',
    image: "/images/products/3.png",
    description: 'Goo More kahve serisi. Eşsiz lezzetleriyle vücudunuzu destekleyin!',
    products: [
      {
        id: 'coffee-1',
        price: 1600,
        name: 'CLASSIC',
        image: "/images/products/classic.jpg",
        description: 'Bir kahveden fazlası!'
      },
    
      {
        id: 'coffee-3',
        price: 1400,
        name: 'LATTE',
        image: "/images/products/latte1.jpg",
        description: 'Bir kahveden fazlası!'
      }
    ]
  },
 ];

export const stats = [
  {
    id: 1,
    icon: 'Users',
    value: '15M+',
    label: 'Ürün Kullanıcısı'
  },
  {
    id: 2,
    icon: 'Heart',
    value: '%98',
    label: 'Müşteri Memnuniyeti'
  },
  {
    id: 3,
    icon: 'Globe',
    value: '100+',
    label: 'Ülkede'
  },
  {
    id: 4,
    icon: 'Package',
    value: '23',
    label: 'Ürün Sayısı'
  }
];

export const certificates = [
  {
    id: 1,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/m26mb6ng_1.jpg',
    date: ''
  },
  {
    id: 2,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/dv19l4um_2.jpg',
    date: ''
  },
  {
    id: 3,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/t0bzqq3q_3.jpg',
    date: ''
  },
  {
    id: 4,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/q1jyqbuu_4.jpg',
    date: ''
  },
  {
    id: 5,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/xa3lfm1m_5.jpg',
    date: ''
  },
  {
    id: 6,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/k9sc1wmy_6.jpg',
    date: ''
  },
  {
    id: 7,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/8ttn9yxw_7.jpg',
    date: ''
  },
  {
    id: 8,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/v3hwh7hl_8.jpg',
    date: ''
  },
  {
    id: 9,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/axfr38vv_9.jpg',
    date: ''
  },
  {
    id: 10,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/shhtljzb_10.jpg',
    date: ''
  },
  {
    id: 11,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/80hf0nt8_11.jpg',
    date: ''
  },
  {
    id: 12,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/do2vr81s_12.jpg',
    date: ''
  },
  {
    id: 13,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/9wm68u8o_13.jpg',
    date: ''
  },
  {
    id: 14,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/70v09q18_14.jpg',
    date: ''
  },
  {
    id: 15,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/a47poimi_15.jpg',
    date: ''
  },
  {
    id: 16,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/l7z875nc_16.jpg',
    date: ''
  },
  {
    id: 17,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/n9z8jplq_17.jpg',
    date: ''
  },
  {
    id: 18,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/b8z3dc2j_18.jpg',
    date: ''
  }
];

export const faqs = [
  {
    id: 1,
    question: 'Goo More ürünleri nasıl sipariş edebilirim?',
    answer: 'Sipariş için goomorebackoffice.com üzerinden hızlıca alışverişe başlayabilirsiniz.'
  },
  {
    id: 2,
    question: 'Ürünler kargoya ne zaman verilir?',
    answer: '1-5 iş günü içersinde kargoya verilir.'
  },
  {
    id: 3,
    question: 'Resmi site mi?',
    answer: 'Goo More resmi sitesidir.'
  },

  {
    id: 4,
    question: 'Sorularım olması halinde size nerden ulaşabilirim?',
    answer: 'Whatsapp iletişim kanalımızdan herhangi bir sorunuz yada yardımcı olmamızı istediğiniz bilgi edinme, sipariş, ürün kullanımı gibi Goo More\'a ait tüm konularda her zaman yanınızdayız.'
  }
];

export const aboutInfo = {
  title: 'Hakkımızda',
  description: 'Goo More ile ürün kullanımı ve doğru yönlendirme için buradayız. Detaylı bilgi ve sorularınız için iletişime geçebilirsiniz.',
  mainText:
  "Kaliteli ürünlerimizi yakından inceleyebilir, markamız hakkında detaylı bilgi edinebilir ve en güncel ürünlerimizi keşfedebilirsiniz. Ürün siparişleri ve resmi satış işlemleri, güvenli altyapıya sahip GooMore BackOffice sistemi goomorebackoffice.com üzerinden gerçekleştirilmektedir."
};

export const contactInfo = {
  phone: '+90 537 210 14 52',
  whatsapp: '+905372101452',
  email: 'goomoreinternational@gmail.com'
};